export class RestoreFSxRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "destination",
            "baseName": "destination",
            "type": "FSxRestoreDestination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreFSxRequest.attributeTypeMap;
    }
    constructor() {
    }
}
